import { useJobCountsStore } from '@store/jobCounts';
import { useUserStore } from '@store/user';

export function useJobCounts() {
    const jobCountsStore = useJobCountsStore();
    const userStore = useUserStore();

    onMounted(async () => {
        if (userStore.isCentralContext) {
            return;
        }

        if (userStore.isRestrictedFieldStaff()) {
            return;
        }

        await jobCountsStore.fetchCounts();
        await jobCountsStore.startListener();
    });

    onUnmounted(async () => {
        await jobCountsStore.stopListener();
    });

    return {
        newLeadsCount: computed(() => jobCountsStore.getNewLeadsCount),
        pendingJobsCount: computed(() => jobCountsStore.getPendingJobsCount),
        conflictsCount: computed(() => jobCountsStore.getConflictsCount),
        isFetching: computed(() => jobCountsStore.getIsFetching),
        error: computed(() => jobCountsStore.getError),
        refetch: () => jobCountsStore.fetchCounts(),
    };
}
